/* src/app/forms/produtos/viavarejo/viavarejo-category/viavarejo-category.component.scss */
.content {
  position: relative;
  padding-top: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 6px;
}
.content-tree {
  display: flex;
  flex-direction: column;
  height: 50vh;
  overflow: auto;
  padding: 15px;
}
.pointerMenu {
  cursor: pointer;
}
/*# sourceMappingURL=viavarejo-category.component.css.map */
